import scenarioImages from '../scenarioImages'

export default {
  slug: 'inm13-s1',
  title: 'INM13-S1',
  i18nKey: 'AutomotiveInsProducts.inm13s1',
  heroTitleSize: 'compact',
  images: {
    hero: require('@/assets/images/pixso-automotive-detail/inm13s1-hero.png'),
    description: require('@/assets/images/pixso-automotive-detail/inm13s1-description.png'),
    feature: require('@/assets/images/pixso-automotive-detail/inm13s1-feature.png')
  },
  descriptionTags: [
    { key: 'interface', image: require('@/assets/images/pixso-automotive-detail/icon-interface.svg') },
    { key: 'gnss', image: require('@/assets/images/pixso-automotive-detail/icon-gnss.svg') },
    { key: 'rtk', image: require('@/assets/images/pixso-automotive-detail/icon-rtk.svg') },
    { key: 'imu', image: require('@/assets/images/pixso-automotive-detail/icon-imu.svg') }
  ],
  featureTags: [
    { key: 'automotive', image: require('@/assets/images/pixso-automotive-detail/icon-automotive.svg') },
    { key: 'dualFrequency', image: require('@/assets/images/pixso-automotive-detail/icon-dualfrequency.svg') },
    { key: 'highFrequency', image: require('@/assets/images/pixso-automotive-detail/icon-highfrequency.svg') },
    { key: 'reliable', image: require('@/assets/images/pixso-automotive-detail/icon-reliable.svg') }
  ],
  scenarios: [
    { key: 'tunnelFork', image: scenarioImages.tunnelFork },
    { key: 'parking', image: scenarioImages.parking },
    { key: 'overpass', image: scenarioImages.overpass },
    { key: 'urbanCanyon', image: scenarioImages.urbanCanyon },
    { key: 'complexTraffic', image: scenarioImages.complexTraffic },
    { key: 'treeLinedStreet', image: scenarioImages.treeLinedStreet }
  ],
  specTabs: [
    {
      labelKey: 'ProductSpecs.tabs.basic',
      rows: [
        { labelKey: 'ProductSpecs.rows.productModel', value: { valueKey: 'ProductSpecs.values.tbd' } },
        { labelKey: 'ProductSpecs.rows.productType', value: { valueKey: 'ProductSpecs.values.insModule' } },
        { labelKey: 'ProductSpecs.rows.dataInterface', value: [{ valueKey: 'ProductSpecs.values.tbd' }] },
        { labelKey: 'ProductSpecs.rows.operatingVoltage', value: { valueKey: 'ProductSpecs.values.tbd' } },
        { labelKey: 'ProductSpecs.rows.operatingTemperature', value: { valueKey: 'ProductSpecs.values.tbd' } },
        { labelKey: 'ProductSpecs.rows.protectionRating', value: { valueKey: 'ProductSpecs.values.tbd' } }
      ]
    },
    { labelKey: 'ProductSpecs.tabs.gnss', rows: [] },
    { labelKey: 'ProductSpecs.tabs.imu', rows: [] },
    { labelKey: 'ProductSpecs.tabs.navigationPerformance', rows: [] }
  ]
}
